import React from "react";

import { parseCurrency } from "../../../../utils";

import * as Styles from "./styles";

export function UpgradeAvailableCard({
  currentPlanValue,
  newPlanValue,
  daysAmount,
  onClick,
}) {
  const planName = `${currentPlanValue?.slice(0, 2)}`;

  return (
    <Styles.CardContainer>
      <Styles.CardTitle>Novidade Correios Celular!</Styles.CardTitle>
      <Styles.CardDescription>
        Turbine seu plano {planName} por apenas {parseCurrency(newPlanValue)} e
        fique ativo por {daysAmount} dias com muito mais internet.
      </Styles.CardDescription>
      <Styles.CardButton onClick={onClick}>Eu quero!</Styles.CardButton>
    </Styles.CardContainer>
  );
}
